var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fs tooltip is-tooltip-left",attrs:{"data-tooltip":_vm.tooltip},on:{"click":function($event){_vm.fullscreen()}}},[_c('fs-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }